import moment from 'moment'

const DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']

export type BranchOpenStatus = { open: boolean, label: string | null }

export function getBranchOpenStatus(workingHours: any): BranchOpenStatus {
  if (!workingHours || !Array.isArray(workingHours)) return { open: false, label: null }
  const now = moment()
  const todayKey = DAY_KEYS[now.day()]
  const today = workingHours.find((h: any) => h?.day === todayKey)
  if (!today || today.isOff || !today.start || !today.end) return { open: false, label: null }
  const start = moment(today.start, ['HH:mm', 'H:mm'])
  const end = moment(today.end, ['HH:mm', 'H:mm'])
  if (!start.isValid() || !end.isValid()) return { open: false, label: null }
  const nowMinutes = now.hours() * 60 + now.minutes()
  const startMinutes = start.hours() * 60 + start.minutes()
  const endMinutes = end.hours() * 60 + end.minutes()
  return { open: nowMinutes >= startMinutes && nowMinutes <= endMinutes, label: `${today.start}–${today.end}` }
}

export type WorkingHoursRow = { day: string, time: string }

export function summariseWorkingHours(workingHours: any): WorkingHoursRow[] {
  if (!workingHours || !Array.isArray(workingHours) || workingHours.length === 0) return []
  const open = workingHours.filter((h: any) => !h?.isOff && h?.start && h?.end)
  if (open.length === 0) return [{ day: 'Бүгд', time: 'Амарна' }]
  const groups: { days: any[], time: string }[] = []
  for (const h of open) {
    const time = `${h.start}–${h.end}`
    const last = groups[groups.length - 1]
    if (last && last.time === time) last.days.push(h)
    else groups.push({ days: [h], time })
  }
  return groups.map(g => ({
    day: g.days.length > 1 ? `${g.days[0].name || ''}–${g.days[g.days.length - 1].name || ''}`.trim() : (g.days[0].name || ''),
    time: g.time,
  }))
}
